import { createFileRoute } from "@tanstack/react-router";

import { integerParam } from "../../../lib/url-state";
import { EpisodePage } from "../../../workspaces/library/pages/EpisodePage";

export const Route = createFileRoute(
  "/_console/p/$org/$project/library/episodes/$sessionId/$episodeId",
)({
  validateSearch: (search: Record<string, unknown>): { readonly t?: number } => ({
    t: integerParam(search.t, { min: 0 }),
  }),
  component: EpisodeRoute,
});

/** One floor recording, playing — the address Production links to. */
function EpisodeRoute() {
  const { sessionId, episodeId } = Route.useParams();
  const { t } = Route.useSearch();
  // A new episode is a new page: its review draft and chosen problem start over.
  return <EpisodePage key={`${sessionId}/${episodeId}`} sessionId={sessionId} episodeId={episodeId} startMs={t} />;
}
